var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 503,
    viewBox: "0 0 500 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 185,
    r: 184.5,
    transform: "matrix(-1 0 0 1 435 65)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 249.5,
    transform: "matrix(-1 0 0 1 500 0)",
    stroke: "white",
    strokeOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 496 311)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 370 23)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 65 83)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 72 223)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 242 60)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 27 349)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 423 170)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 147 395)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 356 400)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    transform: "matrix(-1 0 0 1 228 493)",
    fill: "#774FFC",
    stroke: "#774FFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingLeft);
export default __webpack_public_path__ + "static/media/ring_left.26cffa262dc454564360e27d2a6ec191.svg";
export { ForwardRef as ReactComponent };